<template>
  <div :class="{
    'me': isMe,
    'profile-container': profileType,
    'banner-container': bannerType,
    }">
    <img v-if="url" :src="url"/>
    <div v-else>
      <font-awesome-icon v-if="profileType"
        :icon="['fa', 'user-circle']" size="10x" :style="{ color: 'lightgray' }"/>
      <user-profile-default-banner v-if="bannerType"></user-profile-default-banner>
    </div>
    <image-uploader
      v-if="isMe"
      ref="imageUploader"
      :imageType="imageType"
      :width="imageUploadProperties[imageType].width"
      :height="imageUploadProperties[imageType].height"
      :shape="imageUploadProperties[imageType].shape"
      :uploadUrl="`/upload/${this.imageType}`"
      @uploaded="$emit('change')">
      <button class="upload-image-button" aria-label="Upload Photo">
        <font-awesome-icon :icon="['fa', 'camera']" size="2x" />
        <span v-if="profileType">Upload Photo</span>
        <span v-if="bannerType">Upload Cover Photo</span>
      </button>
    </image-uploader>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import UserProfileDefaultBanner from '@/components/user-profile/UserProfileDefaultBanner.vue';
import ImageUploader from '@/components/ImageUploader.vue';

export default {
  name: 'UserProfilePicture',
  components: {
    UserProfileDefaultBanner,
    ImageUploader,
  },
  data() {
    return {
      imageUploadProperties: {
        profile: {
          width: 400,
          height: 400,
          shape: 'circle',
        },
        banner: {
          width: 750,
          height: 250,
          shape: 'square',
        },
      },
    };
  },
  props: {
    url: {
      type: String,
    },
    isMe: {
      type: Boolean,
      default: false,
    },
    imageType: {
      type: String,
      validator: val => ['profile', 'banner'].includes(val),
    },
  },
  computed: {
    ...mapState('auth', ['backendAxios']),
    profileType() {
      return this.imageType === 'profile';
    },
    bannerType() {
      return this.imageType === 'banner';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.profile-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem auto;
  background-color: #FFF;
  width: 10rem;
}

.profile-container > img {
  width: 10rem;
  height: 10rem;
  border-radius: 50%;
}

.profile-container > div {
  margin: 0 auto;
}


.profile-container .picture-upload {
  top: 0rem;
  padding-top: 0.5rem;
  text-align: center;
}

.banner-container {
  position: relative;
}

.banner-container > img {
  width: 100%;
  max-height: 40rem;
  max-width: 120rem;
  min-height: 10rem;
  background-size: cover;
}

.banner-container .picture-upload {
  top: 1rem;
  left: 1rem;
  position: absolute;
}

.default-banner {
  padding: 7rem 0 0 0;
}

.upload-image-button {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 2px solid lightgray;
  color: #333333;
  background-color: white;
  font-size: 0.75rem;
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 0.325rem;
  letter-spacing: 1px;
  &:hover {
    filter: brightness(50%);
  }
}

.upload-image-button > span {
  margin-left: 0.5rem;
}

</style>
